<template>
  <div>
    <div class="banner">
      <div class="titleSub">Talent recruitment</div>
      <div class="title wow animate__animated durationTime animate__fadeInUp">人才招聘</div>
      <div class="desc wow animate__animated durationTime animate__fadeInUp">携手志同道合的伙伴，期待您的加入！</div>
    </div>
    <div class="coll">
      <div>
        <div class="titleSub">Collaborative consulting</div>
        <div class="title wow animate__animated durationTime animate__fadeInUp">合作咨询</div>
        <div class="contact wow animate__animated durationTime animate__fadeInUp">
          <img class="pic" src="../../assets/image/about/tel.png">
          <div  class="desc">服务热线：</div>
          <div class="tel">18617131848</div>
        </div>
        <div class="contact wow animate__animated durationTime animate__fadeInUp">
          <img style="width: 0.1662rem;height: 0.1246rem" class="pic" src="../../assets/image/about/email.png">
          <div  class="desc">电子邮箱：</div>
          <div class="tel">info@magicwifi.com.cn</div>
        </div>
        <div class="contact wow animate__animated durationTime animate__fadeInUp">
          <img style="width: 0.1455rem;height: 0.1819rem"  class="pic" src="../../assets/image/about/address.png">
          <div class="desc">联系地址：</div>
          <div class="tel">深圳市南山区科技园南长虹科技大厦2105</div>
        </div>
      </div>
      <div class="wx-public wow animate__animated durationTime animate__fadeInUp">
        <img class="wx-public-img" src="@/assets/image/index/wx-public.jpg">
        <div class="wx-public-text">扫码联系我们</div>
      </div>
    </div>
    <div class="recruitment">
      <div
        class="item wow animate__animated durationTime animate__fadeInUp"
        v-for="(item, index) in dataList"
        :key="index"
      >
        <div class="job">{{item.title}}</div>
        <div class="info">
          <div class="con">{{item.type}}</div>
          <div class="con">{{item.experience}}</div>
          <div class="con">{{item.address}}</div>
          <div class="con">{{item.date}}</div>
        </div>
        <div style="margin-top: 0.4rem;line-height: 0.23rem;">
          <div class="req" v-for="(con,i) in item.requirement" :key="'req' + i">
            {{i+1}}、{{con}}
          </div>
        </div>

      </div>
    </div>
    <div class="paging">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size.sync="pageSize"
        :current-page.sync="currentPage"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import requirementData from "./recruitment";
export default {
  name: "contact",
  data() {
    return {
      dataList:[],
      currentPage: 1,
      pageSize: 2,
      total: 0
    };
  },
  created() {
    this.getList();
  },
  computed: {},
  mounted() {
    // init wow
    const wow = new WOW({
      boxClass: "wow", //需要执行动画元素的Class
      animateClass: "animated_lightSpeedIn", //animation.css动画的Class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备执行动画
      live: true //异步加载的内容是否有效
    });
    wow.init();
  },
  methods: {
    getList() {
      let datas = [...requirementData];
      const datasCopy = [...datas];
      this.dataList = datasCopy.splice(
        (this.currentPage - 1) * this.pageSize,
        this.pageSize
      );
      this.total = datas.length;
    },
    handleCurrentChange(page){
      this.currentPage=page;
      this.getList();
    }
  }
}
</script>

<style scoped lang="scss">
.banner {
  width: 100%;
  height: 5.8rem;
  background: url('../../assets/image/about/talent-bg.png') center no-repeat;
  background-size: cover;
  padding-left: 2.18rem;
  .title {
    font-size: 0.44rem;
    font-weight: 500;
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    margin-top: 2.75rem;
    position: relative;
    color: #fff;
    display: inline-block;
  }
  .titleSub {
    content: "NEWS";
    position: absolute;
    margin-top: 2.44rem;
    font-size: 0.44rem;
    font-weight: 500;
    color: rgb(169 160 160 / 51%);
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    letter-spacing: 0.02rem;
  }
  .desc{
    font-weight: 400;
    font-size: 0.24rem;
    color: #FFFFFF;
    margin-top: 0.2rem;
  }
}
.coll {
  width: 100%;
  background: url('../../assets/image/about/coll-bg.png') center no-repeat;
  background-size: cover;
  padding:1rem 2.18rem 1.4rem 2.18rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title {
    font-size: 0.34rem;
    font-weight: 500;
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    margin-top: 0.24rem;
    position: relative;
    color: #333333;
    display: inline-block;
    margin-bottom: 0.55rem;
  }
  .titleSub {
    position: absolute;
    font-size: 0.34rem;
    font-weight: 500;
    //color: rgba(255, 255, 255, 0.51);
    color: #c8c8c8;
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    letter-spacing: 0.02rem;
  }
  .contact{
    display: flex;
    margin-bottom: 0.43rem;
    align-items: center;
    .pic{
      width: 0.17rem;
      height: 0.17rem;
      margin-right: 0.1rem;
    }
    .desc{
      width: 0.8rem;
      font-size: 0.16rem;
      font-weight: 400;
      color: #333333;
    }
    .tel{
      color: #333333;
      font-weight: bold;
      font-size: 20px;
      font-family: DIN Alternate, DIN Alternate;
    }
  }
  .wx-public{
    display: flex;
    flex-direction: column;
    align-items: center;
    .wx-public-img{
      width: 1.66rem;
      height: 1.66rem;
    }
    .wx-public-text{
      margin-top: 0.2rem;
      font-weight: 400;
      font-size: 0.16rem;
      color: #333333;
    }
  }

}
.recruitment{
  padding: 1rem 2.18rem 1.4rem 2.18rem;
  .item{
    padding: 0.4rem 0 0.4rem 0.8rem;
    background: #F3F3F3;
    box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
    margin-bottom: 0.2rem;
    .job{
      font-weight: 400;
      font-size: 0.24rem;
      color: #333333;
    }
    .info{
      margin-top: 0.2rem;
      display: flex;
      .con{
        font-weight: 400;
        font-size: 0.16rem;
        color: #333333;
        border-right: 0.01rem #9c9393 solid;
        padding: 0 0.1rem;

      }
      .con:last-child{
        border: 0;
      }
      .con:first-child{
        padding-left: 0;
      }
    }
    .req{
      font-weight: 400;
      font-size: 0.14rem;
      color: #333333;
    }
  }
  .item:last-child{
    margin-bottom: 0;
  }
}
</style>
<style scoped>
.paging {
.el-pagination {
  padding: 0;
  color: #333 !important;
  display: flex;
  justify-content: center;
  background: #fef100;
}
.el-pagination button {
  margin: 0 !important;
  height: 0.8rem !important;
  line-height: 0.8rem !important;
  min-width: 0.8rem !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #fdfce3 !important;
  color: #333;
}
.el-pager li {
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
  font-size: 0.16rem;
  height: 0.8rem !important;
  line-height: 0.8rem !important;
  width: 0.72rem;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background-color: transparent;
  color: #333 !important;
  transition: all 0.3s ease-in-out;
&:hover {
   background-color: rgba(253, 252, 227, 0.8) !important;
 }
}
.el-pagination .btn-next .el-icon,
.el-pagination .btn-prev .el-icon {
  font-size: 0.14rem;
  color: #333;
  font-weight: 400;
}
.el-icon-arrow-left:before {
  content: "上一页";
}
.el-icon-arrow-right:before {
  content: "下一页";
}
}
</style>



// WEBPACK FOOTER //
// src/pages/about/contact.vue